import {
  Box, Dialog, DialogActions, DialogContent, DialogTitle, MenuItem, Select,
} from '@mui/material';
import { SecurityInventoryCategory } from '@x-guard/xgac-types/xgac';
import { useMemo, useState } from 'react';
import { Button, Form, useTranslate } from 'react-admin';
import { IconField } from '../../../components/fields/IconField';
import { InventoryCategoryIconName } from '../../../components/icons/inventoryCategoryIcons';
import { AddItemDialog } from './AddItemDialog';

export const CreateItemSection = (props: {
  categories: SecurityInventoryCategory[];
  map: L.Map | null;
}) => {

  const translate = useTranslate();

  const [showCategories, setShowCategories] = useState(false);
  const [selectedCategoryId, setSelectedCategoryId] = useState<string>('');
  const [addDialogOpen, setAddDialogOpen] = useState(false);

  const selectedCategory = useMemo(() => {

    return props.categories.find((c) => c._id === selectedCategoryId) ?? null;

  }, [props.categories, selectedCategoryId]);

  return (
    <Box sx={{
      display: 'flex', flexDirection: 'column', gap: 1, width: '100%',
    }}>
      <button
        type="button"
        className="add-device-button"
        onClick={() => setShowCategories((open) => !open)}
        style={{
          width: '100%',
          height: 40,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: 0,
        }}
      >
        <span>{translate('resources.security-inventory-items.text.add_item')}</span>
      </button>
      {showCategories && (
        <Dialog open={showCategories} onClose={() => setShowCategories(false)} maxWidth="xs" fullWidth>
          <DialogTitle>{translate('resources.security-inventory-categories.text.select_category')}</DialogTitle>
          <DialogContent>
            <div style={{ marginTop: '25px' }}>
              <Form
                id="create-item-form"
                onSubmit={() => {

                  if (!selectedCategoryId) {

                    return;

                  }

                  setAddDialogOpen(true);
                  setShowCategories(false);

                }}
              >
                <Select
                  size="small"
                  fullWidth
                  displayEmpty
                  value={selectedCategoryId}
                  onChange={(e) => setSelectedCategoryId(e.target.value)}
                  renderValue={(selected) => {

                    if (!selected || !selectedCategory) {

                      return <span style={{ color: '#888' }}>{translate('resources.security-inventory-categories.text.select_category')}</span>;

                    }
                    return (
                      <Box sx={{
                        display: 'flex', alignItems: 'center', gap: 1, minWidth: 0,
                      }}>
                        <IconField
                          iconName={selectedCategory.icon as InventoryCategoryIconName}
                          source={selectedCategory.icon}
                        />
                        <Box component="span" sx={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                          {selectedCategory.name}
                        </Box>
                      </Box>
                    );

                  }}
                >
                  {props.categories.map((category) => (
                    <MenuItem key={category._id} value={category._id}>
                      <IconField iconName={category.icon as InventoryCategoryIconName} source={category.icon} />
                      <span style={{ marginLeft: '10px' }}></span>
                      {category.name}
                    </MenuItem>
                  ))}
                </Select>
              </Form>
            </div>
          </DialogContent>
          <DialogActions>
            <Button label="general.text.close" size="medium" onClick={() => setShowCategories(false)} />
            <Button
              label="general.text.confirm"
              size="medium"
              variant="contained"
              type="submit"
              form="create-item-form"
            />
          </DialogActions>
        </Dialog>
      )}

      <AddItemDialog
        open={addDialogOpen}
        category={selectedCategory}
        map={props.map}
        onClose={() => {

          setAddDialogOpen(false);
          setSelectedCategoryId('');

        }}
      />

    </Box>
  );

};
